import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { OffersInNegotiationService, OffersInNegotiationServiceData } from "../../services/offersInNegotiationKpi/offersInNegotiation.service";
import { ColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class OffersInNegotiationData {
    public offerCount: number;

    constructor(offerCount: number) {
        this.offerCount = offerCount;
    }
}

export class OffersInNegotiationDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}


@Component({
    selector: 'offers-in-negotiation-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class OffersInNegotiationKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<OffersInNegotiationService, OffersInNegotiationServiceData, OffersInNegotiationData, OffersInNegotiationDetailData>
    implements OnDestroy {
    public getClassName() { return "OffersInNegotiationKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryDetailService: OffersInNegotiationService) {
        super(zone, logger, summaryDetailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: OffersInNegotiationServiceData, updateRequested: Boolean): OffersInNegotiationData {
        if (data.consultantEntry) {
            let thisWeek = moment().isoWeek();
            let now = moment();

            if (moment(data.consultantEntry.offersInNegotiationUpdateTimestamp).isoWeek() == thisWeek) {
                let diff = moment.duration(now.diff(moment(data.consultantEntry.offersInNegotiationUpdateTimestamp)));
                if (diff.hours() >= 4) {
                    return new OffersInNegotiationData(data.consultantEntry.offersInNegotiationCount);
                }
                else {
                    if (this.summaryData) {
                        if (updateRequested) {
                            this.messageDialog.open();
                            return new OffersInNegotiationData(data.consultantEntry.offersInNegotiationCount);
                        }
                        else {
                            return new OffersInNegotiationData(data.consultantEntry.offersInNegotiationCount);
                        }
                    }
                    else {
                        return new OffersInNegotiationData(data.consultantEntry.offersInNegotiationCount);
                    }
                }

            } else {
                return this.getDefaultSummaryData();
            }
        } else {
            return this.getDefaultSummaryData();
        }
    }

    protected getDefaultSummaryData(): OffersInNegotiationData {
        let data = new OffersInNegotiationData(0);
        return data;
    }

    protected extractUpdateTime(data: OffersInNegotiationServiceData): Date {
        if (data.consultantEntry) {
            return data.consultantEntry.offersInNegotiationUpdateTimestamp;
        } else {
            return new Date();
        }
    }

    protected processDetailData(data: OffersInNegotiationServiceData): OffersInNegotiationDetailData {

        if (data.consultantEntry) {
            let columnDefinitions = [
                new TextColumnDefinition("Razón social"),
                new TextColumnDefinition("Segmento"),
                new TextColumnDefinition("Fecha"),
                new TextColumnDefinition("Potencial"),
                new TextColumnDefinition("Margen")

            ];

            let tabledata = [];
            let thisWeek = moment().isoWeek();
            for (let offer of (data.consultantEntry.offersInNegotiation || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek)) {

                data.consultantEntry.offersInNegotiation.sort(function (a, b) {
                    if (a.date == b.date) {
                        if (a.segment > b.segment) {
                            return 1;
                        }
                        if (a.segment < b.segment) {
                            return -1;
                        }
                        return 0;
                    }
                    else {
                        if (a.date > b.date) {
                            return 1;
                        }
                        if (a.date < b.date) {
                            return -1;
                        }
                        // a must be equal to b
                        return 0;
                    }

                });

                tabledata.push([
                    offer.trading_name,
                    "S" + offer.segment,
                    moment(offer.date).format("DD/MM/YYYY"),
                    offer.potential,
                    offer.min_margin
                ]);

            }
            return new OffersInNegotiationDetailData(columnDefinitions, tabledata);
        } else return this.getDefaultDetailData();
    }

    protected getDefaultDetailData() {
        let columnDefinitions = [
            new TextColumnDefinition("Razón social"),
            new TextColumnDefinition("Segmento"),
            new TextColumnDefinition("Fecha"),
            new TextColumnDefinition("Potencial"),
            new TextColumnDefinition("Margen")
        ];

        return new OffersInNegotiationDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}
